'use client';

import { useCallback } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import useTranslations from '@/hooks/useTranslations';
import { SectionFields } from '@/types/general';
import DataEditor from '@/components/DataEditor';

export default function NewsletterMarketingWebsite() {
  const { t } = useTranslations();

  const formFields: SectionFields[] = [
    {
      fields: [
        {
          label: '',
          field: 'email',
          placeholder: t('footer.form.email'),
          type: 'email',
          size: 8,
          required: true,
        },
      ],
    },
  ];

  const handleChange = useCallback(() => {
    // Submitting does nothing yet. The pending call is toggleNewsletterSubscription with
    // { userId, subscribed }, followed by the 'footer.suscribed' success notification.
  }, []);

  return (
    <Stack direction='column' spacing={0.75} sx={{ maxWidth: { xs: '100%', md: 200 } }}>
      <Typography
        variant='body1'
        sx={{
          color: 'text.primary',
          fontWeight: 'bold',
        }}
      >
        {t('footer.newsletter')}
      </Typography>

      <Stack direction='column' spacing={0} sx={{ '.MuiStack-root': { pb: '4px' } }}>
        <DataEditor
          formFields={formFields}
          defaultValues={{}}
          onSubmit={handleChange}
          showSubmitButton
          isMarketingWebsite
          submitText={t('footer.stayUpToDate')}
        />
      </Stack>
    </Stack>
  );
}
